import React from "react";
import { FaPhoneAlt } from "react-icons/fa"

export default function OrderPage() {
    return (
        <div>
            <div>
                 <h2 style={{
  fontSize: "2rem",
  marginBottom: "25px",
  color: "#343a40",
  textAlign: "center", /* Changed to center */
  userSelect: "none"
}}>Your Dream Wedding Hampers Await!</h2>
            </div>
         
      <div 
  style={{ 
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
    marginBottom: "20px",
    paddingLeft: "20px",
    paddingRight: "20px",
    width: "100%"
  }}
>
  <video
    className="video-player"
    style={{
      width: "100%",
      maxWidth: "420px",         // 🔥 proportional to 2160x3840
      aspectRatio: "9 / 16",     // 🔥 exact ratio of your video
      borderRadius: "22px",
      objectFit: "cover",
      boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
    }}
    controls
    muted
    autoPlay
    loop
    controlsList="nodownload"
    disablePictureInPicture
  >
    <source src="/thedata/pubHome.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</div>



            <div
                style={{
                    fontFamily: "Verdana, sans-serif",
                    fontSize: "1.2em",
                    marginLeft: "20px",
                    marginRight: "20px",
                    userSelect: "none", 
                    pointerEvents: "none",
                    autoPlay:"true",
                }}
            >
               Don't let wedding planning stress you out! Simply call us to effortlessly book and customize the perfect wedding hampers.
                They'll delight your guests and add an unforgettable touch to your special day.
                At The Dry Fruit Shop, we craft beautiful baskets for every occasion. We handle
                  orders for special events like engagements, Nikah, and other functions. Choose from our wide selection, including dry fruit,
                 chocolate, fresh fruit,and toffee baskets, as well as Mehndi trays, and Nikah pouches.Please book your order at least 7 days before
                   your occasion. All orders are collected at our official outlet, M.Y Bhat & Sons, located at
                 Maharaja Bazar, Srinagar, Kashmir. You're always welcome to visit us,
              to help you visualize and customize your baskets, we've created videos showcasing our work. This way, you can get a
            better idea of the styles and options available.
           For bookings and inquiries, feel free to contact us on the official numbers which are provide in our official websites.
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "20px" }}>
            <div style={{ fontSize: "1.5em", marginBottom: "10px" }}>
                <FaPhoneAlt /> 9906644334 
            </div>
            <div style={{ fontSize: "1.5em" }}>
                <FaPhoneAlt /> 9541558408 
            </div>
        </div>

           
        </div>
    );
}
